import styles from "./NavigationDots.module.scss";

interface NavigationDotsProps {
  count: number;
  activeIndex: number;
  onDotClick: (index: number) => void;
}

export function NavigationDots({
  count,
  activeIndex,
  onDotClick,
}: NavigationDotsProps) {
  return (
    <div
      className={styles.dots}
      role="tablist"
      aria-label="Carousel navigation"
    >
      {Array.from({ length: count }, (_, i) => (
        <button
          key={i}
          type="button"
          role="tab"
          aria-selected={i === activeIndex}
          aria-label={`Slide ${i + 1} of ${count}`}
          className={`${styles.dot} ${i === activeIndex ? styles.dotActive : ""}`}
          onClick={() => onDotClick(i)}
        />
      ))}
    </div>
  );
}
